import { EmptyPageSimulations } from 'components/shared/empty-screen-page'
import SuspendedSimCard from 'components/shared/suspended-sim-card'
import useTranslation from 'next-translate/useTranslation'

const SuspendedSimPage = (props: PropsSuspendendedSim) => {
    const { t } = useTranslation('simulation')
    return props.suspendedSimulations && props.suspendedSimulations.length > 0 ? (
        <div className="w-full  grid grid-cols-1  md:grid-cols-2 lg:grid-cols-3 gap-3">
            {props.suspendedSimulations.map((s) => {
                return (
                    <div key={s._id} className="w-full">
                        <SuspendedSimCard simulation={s} />
                    </div>
                )
            })}
        </div>
    ) : (
        <EmptyPageSimulations
            title={t('emptyState.suspended.title')}
            description={t('emptyState.suspended.description')}
        />
    )
}
export default SuspendedSimPage
